import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import breakpoints from './Theme/breakpoints';

const ImageContainer = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};

  /* stylelint-disable-next-line selector-type-no-unknown */
  progressive-img, img {
    ${({ width }) => `
      width: ${width};
      --img-width: ${width};
    `}
    ${({ objectFit }) => `
      object-fit: ${objectFit};
      --img-object-fit: ${objectFit};
    `}
    ${({ height }) => `
      height: ${height};
      --img-height: ${height};
    `}
    ${({ maxHeight }) => `
      max-height: ${maxHeight};
      --img-max-height: ${maxHeight};
    `}
  }

  display: ${({ showOnlyOn }) => (showOnlyOn === 'desktop' ? 'none' : 'block')};

  @media (min-width: ${breakpoints.lg}px) {
    display: ${({ showOnlyOn }) => (showOnlyOn === 'mobile'
    ? 'none' : 'block')};
  }
`;

const NoScript = styled.noscript`
  min-width: 100%;
`;

const Image = ({
  image,
  src,
  alt,
  width,
  height,
  maxHeight,
  objectFit,
  sizes,
  srcSet,
  showOnlyOn,
  className,
}) => (
  <ImageContainer
    width={width}
    objectFit={objectFit}
    height={height}
    maxHeight={maxHeight}
    showOnlyOn={showOnlyOn}
    className={className}
  >
    {image}
    <NoScript>
      <img
        alt={alt}
        src={src}
        sizes={sizes}
        srcSet={srcSet}
      />
    </NoScript>
  </ImageContainer>
);

Image.propTypes = {
  image: PropTypes.node.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  sizes: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  maxHeight: PropTypes.string,
  objectFit: PropTypes.string,
  srcSet: PropTypes.string,
  showOnlyOn: PropTypes.string,
  className: PropTypes.string,
};

Image.defaultProps = {
  width: 'auto',
  height: 'auto',
  maxHeight: 'none',
  objectFit: 'contain',
  srcSet: undefined,
  showOnlyOn: undefined,
  className: undefined,
};

export default Image;
